import { atBqnTarget } from "common/api";

const parseKeys = (head, translations = {}) =>
  head.split(/\s+/).map((key) => translations[key] || key);

const serviceName = (value) =>
  value === 'IPOTHER-ALL'
    ? "IPOther-All"
    : value.slice(0, 5) + value.slice(5).toLowerCase();

const intoObject = (keys, skipped) => (row) =>
  Object.fromEntries(
    row
      .trim()
      .split(/\s+/)
      .flatMap((value, index) =>
        skipped.includes(keys[index])
          ? []
          : [[
              keys[index],
              keys[index] === "name" ? serviceName(value) : Number(value),
            ]]
      )
  );

// The response of one BQN reports no BQN column, so its flows are attributed
// to the BQN selected in the header, which is the one that was asked for.
export const parseStateActiveSessions = (input, bqnIdShown) => {
  const [head, ...rows] = input.length === 0 ? [] : input.trim().split("\n");
  if (head === undefined) {
    return { connections: [] };
  }

  const translations = {
    STATE: "name",
    CREATED: "created",
    DELETED: "deleted",
    ACTIVE: "active",
  };
  const keys = parseKeys(head, translations);
  const skipped = ["created", "deleted"];
  const ofBqnAsked =
    keys[0] === "BQN" || bqnIdShown === undefined
      ? (connection) => connection
      : (connection) => ({ BQN: Number(bqnIdShown), ...connection });
  const connections = rows.map(intoObject(keys, skipped)).map(ofBqnAsked);
  return { connections };
};

export const flowsStateRetrieval = (mode, bqnId) =>
  ifCl.run(atBqnTarget("show flow all state raw", mode, bqnId));
